module.exports = __webpack_public_path__ + "img/kakamega-county-header-logo.dc3f0eb6.png";